<!--begin::Logo image-->
<a routerLink="/dashboard">
  <ng-container *ngIf="currentLayoutType === 'dark-sidebar'">
    <!-- <img alt="Logo" src="./assets/media/logos/TKC logo 2.png" class="app-sidebar-logo-default" /> -->
    <!-- <img alt="Logo" src="./assets/media/logos/TKC logo 2.png" class="h-lg-20px app-sidebar-logo-default " /> -->
    <img
      alt="Logo"
      src="./assets/media/logos/TKC logo 2.png"
      class="img-fluid h-60px h-lg-60px mt-6 app-sidebar-logo-default"
    />
    <!-- <h1 style="color: #F79123;margin-top: 10px; font-size: 30px;">TKC HR ADMIN</h1> -->
  </ng-container>
  <ng-container *ngIf="currentLayoutType !== 'dark-sidebar'">
    <img
      alt="Logo"
      src="./assets/media/logos/TKC logo 2.png"
      class="img-fluid h-60px h-lg-60px app-sidebar-logo-default theme-light-show"
    />
    <img
      alt="Logo"
      src="./assets/media/logos/TKC logo 2.png"
      class="img-fluid h-60px h-lg-60px app-sidebar-logo-default theme-dark-show"
    />
  </ng-container>

  <img
    alt="Logo"
    src="./assets/media/logos/TKC logo 2.png"
    class="img-fluid h-20px app-sidebar-logo-minimize"
  />
</a>
<!--end::Logo image-->

<ng-container *ngIf="toggleEnabled">
  <!--begin::Sidebar toggle-->
  <div
    id="kt_app_sidebar_toggle"
    class="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate"
    [ngClass]="toggleButtonClass"
    data-kt-toggle="true"
    [attr.data-kt-toggle-state]="toggleState"
    data-kt-toggle-target="body"
    [attr.data-kt-toggle-name]="toggleAttr"
  >
    <app-keenicon name="double-left" class="fs-2 rotate-180"></app-keenicon>
  </div>
  <!--end::Sidebar toggle-->
</ng-container>
